import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import moment from "moment"

export default function notificationReducer(state = initialState.notifications, action) {
    const offSet = new Date().getTimezoneOffset();
    switch (action.type) {
        case types.LOAD_USER_NOTIFICATIONS:
            var latestItemDate = new Date('01/01/1900');
            action.notifications.map(notification => {
                notification.createdOn = moment(notification.createdOn).subtract(offSet, 'm');
                var created = new Date(notification.createdOn);
                if (created > latestItemDate) {
                    latestItemDate = created;
                }
            })
            return {
                ...state,
                items: action.notifications,
                lastLoaded: new Date(),
                latestNotification: latestItemDate
            };
            break;
        case types.UPDATE_NOTIFICATIONS_VIEWED:
            return {
                ...state,
                lastViewed: action.viewedOn
            };
            break;
        case types.UPDATE_NOTIFICATION_OPENED:
            let updatedArray = []
            state.items.map(notification => {
                if (notification.notificationId == action.notificationId) {
                    notification.seenOn = action.openedOn; 
                }
                updatedArray.push(notification)
            })
            return {
                ...state,
                items: updatedArray
            };
            break;
        case types.LOGOUT_SUCCESS:
            return initialState.notifications;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/notificationReducer.js